import { html } from 'htm/preact';
import { TextFieldEntry, TextAreaEntry, CheckboxEntry, isTextFieldEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from 'bpmn-js-properties-panel';
import type { Element } from 'diagram-js/lib/model/Types';

interface ProcessProps {
  element: Element;
  id: string;
  entry: any;
  description: string;
}

export default function processGeneralProps(element: Element) {
  return [
    
    {
      id: 'code',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'title',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'codeTemplate',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
   /* {
      id: 'actions',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
     {
      id: 'activityActions',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'forms',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'form',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'view',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'filterCategory',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'filters',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },*/

  ];
}

function Item(props: ProcessProps) {
  const { element, id, entry } = props;
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  const getValue = (): string => {
    return element.businessObject[id] || '';
  };

  const setValue = (value: string) => {
    return modeling.updateProperties(element, {
      [id]: value
    });
  };

  return html`<${entry}
    id=${id}
    element=${element}
    description=''
    label=${translate(id.charAt(0).toUpperCase() + id.slice(1))}
    getValue=${getValue}
    setValue=${setValue}
    debounce=${debounce}
    tooltip=${translate(props.description)}
  />`;
}


